<template>
  <div>
    <!-- 导入弹窗 -->
    <vxe-modal v-model="importDialog.visible" :destroyOnClose="true" :loading="importDialog.loading" show-footer size="mini" title="导入数据" type="confirm" width="40%" @cancel="handleImportDialogClose" @confirm="handleImportSubmit">
      <div class="import-dialog-content">
        <!-- 文件上传 - 简化版 -->
        <a-upload
          :key="uploadKey"
          v-model:file-list="importDialog.fileList"
          :multiple="false"
          :accept="'.xlsx,.xls,.csv'"
          :auto-upload="false"
          :show-upload-list="true"
          :before-upload="() => false"
          @change="handleFileChange"
          @remove="handleFileRemove"
        >
          <a-button>
            选择文件
          </a-button>
          <div class="upload-tip">支持 .xlsx, .xls, .csv 格式文件，最大10MB</div>
        </a-upload>

        <!-- 下载模板 -->
        <div class="download-template">
          <a-button type="link" @click="downloadTemplate">
            下载导入模板
          </a-button>
        </div>
      </div>
    </vxe-modal>
    <vxe-card size="mini" width="100%">
      <template #title>
        <vxe-select v-model="query.storerId" :options="storers" clearable placeholder="placeholder.storer" @change="refresh"/>
        <vxe-input v-model="query.itemNo" clearable placeholder="business.label.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.itemName" clearable placeholder="business.label.itemName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.lotNo" clearable placeholder="business.label.lotNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.batchNo" clearable placeholder="business.label.batchNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.locationNo" clearable placeholder="business.label.locationNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-select v-model="query.orderStatus" :options="orderStatus" clearable placeholder="business.label.importStatus" @change="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.impConfirm" icon="vxe-icon-download" status="primary" @click="importData"/>
        <vxe-button content="button.validation" icon="vxe-icon-check" status="primary" @click="validation"/>
        <vxe-button content="button.synchronization" icon="vxe-icon-send" status="danger" @click="synchronization"/>
      </template>
      <vxe-table
        ref="table"
        :column-config="{resizable: true}"
        :data="data"
        :edit-config="editConfig"
        :edit-rules="editRules"
        :export-config="{}"
        :height="height"
        :keyboard-config="{isArrow: true}"
        :loading="loading"
        :radio-config="{trigger: 'row'}"
        :row-config="{isCurrent: true, isHover: true}"
        :scroll-x="{enabled: true}"
        align="center"
        border
        keep-source
        round
        show-header-overflow
        show-overflow
        size="mini"
        stripe>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="warehouseNo" title="business.label.warehouseNo" width="80"/>
        <vxe-column field="warehouseName" title="business.label.warehouseName" width="100"/>
        <vxe-column field="storerNo" title="business.label.storerNo" width="80"/>
        <vxe-column field="storerName" title="business.label.storerName" width="120"/>
        <vxe-column field="locationNo" title="business.label.locationNo" width="100"/>
        <vxe-column field="itemNo" title="business.label.itemNo" width="80"/>
        <vxe-column field="itemName" title="business.label.itemName" width="120"/>
        <vxe-column field="barcodes" title="business.label.barcode" width="100"/>
        <vxe-column field="specification" title="business.label.specification" width="120"/>
        <vxe-column field="uom" title="business.label.uom" width="60"/>
        <vxe-column field="lotNo" title="business.label.lotNo" width="100"/>
        <vxe-column field="batchNo" title="business.label.batchNo" width="100"/>
        <vxe-column field="productionDate" title="business.label.productionDate" width="100"/>
        <vxe-column field="validUntil" title="business.label.validUntil" width="100"/>
        <vxe-column field="quantity" title="business.label.quantity" width="80"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:orderStatus}" field="orderStatus" title="business.label.importStatus" width="80"/>
        <vxe-column field="msg" title="business.label.msg"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import Vue from 'vue'
import api from '@/api'
import { SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import { findAll, findEnum, post } from '@/api/Api'
import * as XLSX from 'xlsx'
import { message, Modal } from 'ant-design-vue'

export default {
  name: 'importInventory',
  data() {
    return {
      uploadKey: 0,
      importDialog: {
        visible: false,
        loading: false,
        file: null,
        fileList: []
      },
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      data: [],
      query: { storerId: null, itemNo: '', itemName: '', lotNo: '', batchNo: '', locationNo: '', orderStatus: null },
      storers: [],
      orderStatus: [],
      page: 1,
      size: 20,
      contentSize: 0,
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.8),
      editConfig: { trigger: 'click', mode: 'cell', showStatus: true },
      editRules: {
        no: [
          { required: true, type: 'string', message: '编号不能为空' }
        ],
        name: [
          { required: true, type: 'string', message: '名称不能为空' }
        ]
      }
    }
  },
  created() {
    Promise.all([
      findAll('storerFactory', { available: true }).then(res => {
        if (res.success) {
          this.storers = res.result.map(item => {
            return { label: item.name, value: item.id }
          })
        }
      }),
      findEnum('OrderStatus').then(res => {
        if (res.success) {
          this.orderStatus = res.result.filter(item => item.ordinal === 0 || item.ordinal === 2 || item.ordinal === 3 || item.ordinal === 99).map(item => {
            return { label: item.name, value: item.ordinal }
          })
        }
      })
    ]).then(() => this.refresh())
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('inventoryImportFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    //库存导入
    importData() {
      this.importDialog.visible = true
      this.importDialog.file = null
      this.importDialog.fileList = []
    },
    //数据校验
    validation() {
      this.loading = true
      post(api.importerCheck, { type: 'inventoryImporter' }).then(res => {
        if (res.success) {
          this.refresh()
        }
      }).finally(() => this.loading = false)
    },
    //数据同步
    synchronization() {
      const that = this
      this.$confirm({
        title: '数据同步',
        content: '同步会清除现有库存并进行覆盖，是否继续？',
        onOk() {
          that.execute()
        },
        onCancel() {
        },
        okText: that.$t('button.confirm'),
        cancelText: that.$t('button.cancel'),
        centered: true
      })
    },
    execute() {
      this.loading = true
      post(api.importerExecute, { type: 'inventoryImporter' }).then(res => {
        if (res.success) {
          this.refresh()
        }
      }).finally(() => this.loading = false)
    },
    handleFileChange(info) {
      console.log('文件变化:', info)

      const { file } = info

      // 获取原始文件对象
      const rawFile = file.originFileObj || file

      // 检查文件大小
      if (rawFile.size / 1024 / 1024 > 10) {
        message.error('文件大小不能超过 10MB！')
        this.importDialog.fileList = []
        this.importDialog.file = null
        return
      }

      this.importDialog.file = rawFile
      console.log('已选择文件:', this.importDialog.file)
    },

    handleFileRemove() {
      this.importDialog.file = null
      this.importDialog.fileList = []
      this.uploadKey++

      console.log('文件已清除，组件已刷新')
    },
    handleImportDialogClose() {
      console.log('this.importDialog.file', this.importDialog.file)
      let cp = this
      if (this.importDialog.file && !this.importDialog.loading) {

        Modal.confirm({
          title: '提示',
          content: '确定要取消导入吗？当前选择的文件将不会被保存',
          okText: '确定',
          cancelText: '取消',
          okType: 'danger',  // 对应 Element Plus 的 type: 'warning'，使用 danger 样式表示警告
          onOk() {
            // 确定后的回调
            cp.importDialog.visible = false
            cp.handleFileRemove()
            console.log(cp.importDialog)
          },
          onCancel() {
            // 取消后的回调
          }
        })
      } else {
        this.importDialog.visible = false
        this.handleFileRemove()
      }
    },
    handleImportSubmit() {
      this.loading = true
      const formData = new FormData()
      formData.append('file', this.importDialog.file)
      post(api.importerSave, { type: 'inventoryImporter', 'Content-Type': 'multipart/form-data' }, formData).then(res => {
        if (res.success) {
          this.refresh()
        }
      }).finally(() => this.loading = false)
    },
    downloadTemplate() {
      try {
        // 定义表头
        const headers = ['仓库编号', '货主编号', '货位编号', '商品编号', '商品名称', '商品条码', '包装单位', '包装规格', '批号', '批次', '生产日期', '有效期至', '数量', '备注']

        // 示例数据
        const sampleData = [
          {
            '仓库编号': '10086001',
            '货主编号': '10086002',
            '货位编号': '3A-01-01-11',
            '商品编号': 'LBB0196',
            '商品名称': '林饱饱早餐披萨【奥尔良风味】90g',
            '商品条码': '6936655118187',
            '包装单位': '袋',
            '包装规格': '林饱饱早餐披萨【奥尔良风味】90g',
            '批号': '20260321',
            '批次': '20260411',
            '生产日期': '2026-03-17',
            '有效期至': '2027-03-17',
            '数量': 3544,
            '备注': '示例数据，请按格式填写'
          }

        ]

        // 创建工作簿
        const wb = XLSX.utils.book_new()

        // 创建工作表 - 数据部分
        const wsData = [headers, ...sampleData.map((row) => headers.map((header) => row[header] || ''))]
        const ws = XLSX.utils.aoa_to_sheet(wsData)

        // 设置列宽
        const colWidths = headers.map((header) => ({ wch: Math.max(header.length, 15) }))
        ws['!cols'] = colWidths

        // 设置表头样式
        const headerRange = XLSX.utils.decode_range(ws['!ref'] || 'A1:Z1')
        for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
          const address = XLSX.utils.encode_cell({ r: 0, c: C })
          if (!ws[address]) ws[address] = {}
          ws[address].s = {
            font: { bold: true, color: { rgb: 'FFFFFF' } },
            fill: { fgColor: { rgb: '4472C4' } },
            alignment: { horizontal: 'center', vertical: 'center' }
          }
        }

        // 将工作表添加到工作簿
        XLSX.utils.book_append_sheet(wb, ws, '数据模板')

        // 生成Excel文件
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })

        // 创建Blob对象并下载
        const blob = new Blob([wbout], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })

        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = '库存导入.xlsx'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)

        message.success('Excel模板下载成功！')
      } catch (error) {
        console.error('下载Excel模板失败:', error)
        message.error('模板下载失败，请重试')
      }
    }
  }
}
</script>